export class NpsAndSchedule{
    npsScheduleId?: number;
    npsDescription?: string;
    nps?: string;
    schedule?: string;
    odMetric?: number;
    wtMetric?: number;
    odImperial?: number;
    wtImperial?: number;
}

export class NpsAndSchedules{
    npsSchedules?:NpsAndSchedule[];
}

